// File: components/DutyList/utils/translation.js
export const translateText = async (text) => {
  if (!text) return "";
  try {
    const res = await fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ur&dt=t&q=${encodeURIComponent(
        text
      )}`
    );
    const json = await res.json();
    return json?.[0]?.[0]?.[0] || text;
  } catch (error) {
    console.error("Translation error:", error);
    return text;
  }
};
